import { useSiteContent } from "../context/SiteContentContext";
import { MapPin, Phone, Clock, Video, AlertTriangle } from "lucide-react";

export default function Contact() {
  const { clinic } = useSiteContent();
  return (
    <div data-testid="contact-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
      <span className="inline-block bg-[#D9E4E1] text-slate-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-5">
        Contact & Directions
      </span>
      <h1 className="font-heading text-4xl sm:text-5xl text-slate-900 leading-tight">
        We're here in Banjara Hills
      </h1>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="space-y-5">
          {[
            { icon: MapPin, title: "Clinic Address", lines: [clinic.address] },
            { icon: Phone, title: "Phone", lines: [clinic.phone], href: clinic.phoneHref },
            { icon: Clock, title: "Clinic Hours", lines: [clinic.hours, "Sundays — Closed"] },
            { icon: Video, title: "Online Consultation Hours", lines: [clinic.onlineHours, "15-minute slots · ₹100 per consultation"] },
          ].map((c) => (
            <div key={c.title} className="bg-white rounded-2xl border border-[#EDF1EF] p-6 flex gap-4">
              <span className="w-11 h-11 rounded-xl bg-[#D9E4E1] flex items-center justify-center shrink-0">
                <c.icon className="w-5 h-5 text-[#4A7065]" />
              </span>
              <div>
                <h3 className="font-heading font-semibold text-slate-800">{c.title}</h3>
                {c.lines.map((l) =>
                  c.href ? (
                    <a key={l} href={c.href} className="block text-sm text-slate-600 mt-1 hover:text-[#4A7065]">
                      {l}
                    </a>
                  ) : (
                    <p key={l} className="text-sm text-slate-600 mt-1">{l}</p>
                  )
                )}
              </div>
            </div>
          ))}

          <div className="bg-[#E8DAB2]/40 border border-[#E8DAB2] rounded-2xl p-5 flex gap-3 text-sm text-slate-700">
            <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0 mt-0.5" />
            <span>
              <b>In an emergency, please do not wait for an appointment.</b> Visit the nearest
              hospital emergency department immediately or call emergency services (108).
            </span>
          </div>
        </div>

        <div>
          <iframe
            title="Clinic location - Care Hospitals, Banjara Hills"
            data-testid="contact-map"
            src={clinic.mapEmbed}
            className="w-full h-[420px] lg:h-full min-h-[420px] rounded-2xl border border-[#D9E4E1]"
            loading="lazy"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
